import axios from "axios";
import {
  Message
} from "element-ui";
// create an axios instance
let baseURL = 'https://jsiot.cogiot.net/jsiot'
const service = axios.create({
  baseURL: baseURL, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 100000 // request timeout
});
// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data;
    // if the custom code is not 20000, it is judged as an error.
    if (res.code == 500) {
      Message({
        message: res.message || "Error",
        type: "error",
        showClose: true,
        duration: 2 * 1000
      });
      return Promise.reject(res);
    } else {
      if (res.code == 401) {
        // MessageBox.confirm("你的登录已过期请重新登录", "登录过期", {
        //   confirmButtonText: "重新登录",
        //   cancelButtonText: "取消",
        //   type: "warning"
        // }).then(() => {
        //   store.dispatch("user/resetToken").then(() => {
        //     location.reload();
        //   });
        // });
        return Promise.reject(res);
      } else {
        return res;
      }
    }
  },
  error => {
    console.log("err" + error); // for debug
    return Promise.reject(error);
  }
);

export default service;